<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>生产任务</el-breadcrumb-item>
      <el-breadcrumb-item>待完成任务</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <div v-if="tasks.length == 0">暂无待完成任务。</div>
      <ul v-else class="tasklist">
        <li
          v-for="(task, index) in tasks"
          class="task task-info"
          :class="task.style.taskClass"
        >
          <div>
            <p class="task-title">{{ task.name }}</p>
            <div class>
              {{ task.flow.name }}
            </div>
          </div>
          <div class="actions">
            <span
              @click="startTask(index)"
              class="btn btn-primary"
              v-if="task.status == 1"
              >开始任务</span
            >
            <!-- <span
                    @click="refuseTask(index)"
                    class="text-danger"
                    style="margin-top:8px"
                    v-if="task.status==1"
                  >拒绝任务</span>-->
            <span
              @click="showDoneTaskModal(index)"
              class="btn btn-info"
              v-if="task.status == 2"
              >完成任务</span
            >
            <span
              @click="showDoneTaskModal(index)"
              class="btn btn-danger"
              v-if="task.status == 4"
              >重新完成</span
            >
          </div>
        </li>
      </ul>
    </div>
    <div
      class="modal"
      id="StartTaskModal"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      style="display: none"
    >
      <div class="modal-dialog" style="width: 500px">
        <div class="modal-content">
          <!--Modal header-->
          <div class="modal-header">
            <h4 class="modal-title">上序检验</h4>
          </div>
          <!--Modal body-->
          <div class="modal-body" style="padding-top: 0">
            <div class="form-group">
              <div class="radio">
                <!-- Inline radio buttons -->
                <input
                  id="inspect-yes"
                  class="magic-radio"
                  type="radio"
                  name="inspect"
                  checked
                  value="1"
                  v-model="inspectResult"
                />
                <label for="inspect-yes">合格</label>
                <input
                  id="inspect-no"
                  class="magic-radio"
                  type="radio"
                  name="inspect"
                  value="0"
                  v-model="inspectResult"
                />
                <label for="inspect-no">不合格</label>
              </div>
            </div>
            <div v-if="inspectResult == '0'" class="form-group">
              <input
                class="form-control"
                placeholder="简要说明不合格原因"
                type="text"
                v-model="inspectReason"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button data-dismiss="modal" class="btn btn-default" type="button">
              取消
            </button>
            <button class="btn btn-primary" @click="postStartTask">
              {{ inspectResult == '1' ? '开始任务' : '确认' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="DoneTaskModal"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      style="display: none"
    >
      <div class="modal-dialog" style="width: 500px">
        <div class="modal-content">
          <!--Modal header-->
          <div class="modal-header">
            <h4 class="modal-title">任务反馈</h4>
          </div>
          <!--Modal body-->
          <div class="modal-body" style="padding-top: 0">
            <div v-if="fields.length == 0">没有需要反馈的内容</div>
            <div v-if="errorMsg" class="form-group text-danger">
              {{ errorMsg }}
            </div>
            <div
              v-for="(field, index) in fields"
              class="form-group edit-component"
              v-bind:key="index"
            >
              <label class="control-label">
                {{ field.title }}
                <span
                  v-if="field.extra_json && field.extra_json.unit.length > 0"
                  >（{{ field.extra_json.unit }}）</span
                >
                <span v-if="field.required">*</span>
              </label>
              <input
                v-if="dispalyInput(field.type)"
                class="form-control"
                :placeholder="field.placeholder"
                type="text"
                v-model="field.value"
              />
              <div v-if="field.type == 4">
                <el-select
                  style="width: 100%"
                  size="small"
                  v-model="field.value"
                  :placeholder="field.placeholder"
                >
                  <el-option
                    v-for="item in field.extra_json.options"
                    :key="item"
                    :value="item"
                    :label="item"
                  ></el-option>
                </el-select>
                <!-- <multiselect
                  v-model="field.value"
                  selectedLabel
                  selectLabel
                  deselectLabel=" "
                  :placeholder="field.placeholder"
                  :options="field.extra_json.options"
                >
                  <span slot="noResult">无匹配结果</span>
                  <span slot="noOptions">无可选执行人</span>
                </multiselect> -->
              </div>
              <div v-if="field.type == 5">
                <el-select
                  style="width: 100%"
                  size="small"
                  v-model="field.value"
                  multiple
                  :placeholder="field.placeholder"
                >
                  <el-option
                    v-for="item in field.extra_json.options"
                    :key="item"
                    :value="item"
                    :label="item"
                  ></el-option>
                </el-select>
                <!-- <multiselect
                  v-model="field.value"
                  selectedLabel
                  selectLabel
                  deselectLabel="取消选择"
                  :multiple="true"
                  :placeholder="field.placeholder"
                  :options="field.extra_json.options"
                >
                  <span slot="noResult">无匹配结果</span>
                  <span slot="noOptions">无可选执行人</span>
                </multiselect> -->
              </div>
              <div v-if="field.type == 6">
                <date-picker
                  v-model="field.value"
                  format="YYYY-MM-DD"
                  type="date"
                  value-type="format"
                ></date-picker>
              </div>
              <div v-if="field.type == 7">
                <date-picker
                  v-model="field.value"
                  format="YYYY-MM-DD"
                  type="date"
                  value-type="format"
                ></date-picker>
                <span>至</span>
                <date-picker
                  v-model="field.value2"
                  format="YYYY-MM-DD"
                  type="date"
                  value-type="format"
                ></date-picker>
              </div>
              <div v-if="field.type == 8">
                <el-upload
                  name="file"
                  :on-success="
                    (res, file, fileList) => uploadSuccess(fileList, field)
                  "
                  :on-remove="(file, fileList) => fileRemove(fileList, field)"
                  :limit="8"
                  accept="image/jpeg, image/jpg, image/png"
                  :action="uploadURL"
                  multiple
                >
                  <span class="btn btn-primary btn-file">选择图片</span>
                </el-upload>
                <!-- <span class="btn btn-primary btn-file">
                  选择图片...
                  <input v-on:change="fileChange" type="file" />
                </span>-->
              </div>
              <div v-if="field.type == 9">
                <el-upload
                  name="file"
                  :on-success="
                    (res, file, fileList) => uploadSuccess(fileList, field)
                  "
                  :on-remove="(file, fileList) => fileRemove(fileList, field)"
                  :limit="8"
                  accept=".doc, docx, .pdf, .numbers, .zip, .ppt, .xls, .html, .htm"
                  :action="uploadURL"
                  multiple
                >
                  <span class="btn btn-primary btn-file">选择文件</span>
                </el-upload>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button data-dismiss="modal" class="btn btn-default" type="button">
              取消
            </button>
            <button class="btn btn-primary" @click="doneTask">完成任务</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { undoneTasks, startTask, formDetail, doneTask } from '@/service/getData'
import { taskStyle } from '@/utils/index'
import DatePicker from 'vue2-datepicker'
import Multiselect from 'vue-multiselect'
import { urlPerfix } from '@/config/env'

export default {
  components: { DatePicker, Multiselect },
  data() {
    return {
      tasks: [],
      doneTaskIndex: null,
      fields: [],
      uploadURL: urlPerfix + '/upload',
      errorMsg: null,
      inspectTask: null,
      inspectResult: '1',
      inspectReason: '',
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let res = await undoneTasks()
      this.tasks = res.data.list.map((item) => {
        item.style = taskStyle(item.status)
        return item
      })
    },
    async startTask(index) {
      this.inspectTask = this.tasks[index]
      $('#StartTaskModal').modal('show')
    },
    postStartTask() {
      let that = this
      let data = {
        id: this.inspectTask.id,
        accept: this.inspectResult == '1',
        reason: this.inspectReason,
      }

      startTask(data).then((res) => {
        if (res.code == 0) {
          that.$message({
            showClose: false,
            duration: 1000,
            message: '操作成功！',
            type: 'success',
          })
          that.initData()
          that.inspectTask = null
          that.inspectResult = '1'
          that.inspectReason = ''
        }
        $('#StartTaskModal').modal('hide')
      })
    },
    async showDoneTaskModal(index) {
      this.doneTaskIndex = index
      let task = this.tasks[index]
      let res = await formDetail({ id: task.node.form_id })
      this.fields = res.data.fields.map((item) => {
        item.value = null
        item.value2 = null
        return item
      })
      $('#DoneTaskModal').modal('show')
    },
    async doneTask() {
      console.log(11)
      for (let index = 0; index < this.fields.length; index++) {
        const field = this.fields[index]
        if (field.required && !field.value) {
          this.errorMsg = '请填写完必填项'
          return
        }
      }

      let task = this.tasks[this.doneTaskIndex]
      let data = {
        task_id: task.id,
      }
      let value = []
      this.fields.map((item) => {
        if (item.type == 3) {
          value.push({
            key: item.title,
            type: item.type,
            value:
              item.value +
              (item.extra_json != null ? item.extra_json.unit : ''),
          })
        } else if (item.type == 7) {
          value.push({
            key: item.title,
            value: item.value + ',' + item.value2,
            type: item.type,
          })
        } else {
          value.push({ key: item.title, value: item.value, type: item.type })
        }
      })
      data.value = JSON.stringify(value)

      let res = await doneTask(data)
      $('#DoneTaskModal').modal('hide')
      if (res.code == 0) {
        this.$message({
          showClose: false,
          duration: 1000,
          message: '任务完成',
          type: 'success',
        })
        this.tasks.splice(this.doneTaskIndex, 1)
      }
    },
    dispalyInput(type) {
      return [1, 2, 3].indexOf(type) != -1
    },
    fileChange(e) {
      console.log(e)
    },
    uploadSuccess(fileList, field) {
      var urls = []
      fileList.map((item) => {
        urls.push(item.response.data)
      })
      field.value = urls.join(',')
    },
    fileRemove(fileList, field) {
      var urls = []
      fileList.map((item) => {
        urls.push(item.response.data)
      })
      field.value = urls.join(',')
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}
.actions span {
  display: inline-block;
  cursor: pointer;
}
.tasklist {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.tasklist li {
  width: 48%;
  display: flex;
  justify-content: space-between;
}
.control-label {
  display: block;
}
</style>